import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import TrainingPage from "./components/TrainingPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<TrainingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
